import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["highRangeLabel", "label", "lowRangeLabel", "max", "maxPerRow", "maxWidth", "min", "name", "onChange", "required", "size", "value"];
import partial from 'react-utils/partial';
import { Controllable } from '../Controllable';
import { syntheticEvent } from '../../utils/SyntheticEvent';
import { IconButton } from '../IconButton';
import { FormLabel } from '../FormLabel/FormLabel';
import { ButtonWrapper } from '../ButtonWrapper/ButtonWrapper';
import { Flex } from '../../../components/Flex/Flex';
import { Text } from '../../../components/Text/Text';
import { View } from '../View';
import { lazyEval } from '../../utils/lazyEval';
import { toShorthandSize } from '../../utils/tShirtSizes';
import { toPx } from '../../../utils/toPx';
import { filterProps } from '../../../utils/filterProps';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GAP_BETWEEN_RATING_BUTTONS = 8;
const getButtonWidth = shorthandSize => {
  switch (shorthandSize) {
    case 'xs':
      return '26px';
    case 'sm':
      return '32px';
    default:
      return '40px';
  }
};
const calculateWidth = (max, min, shorthandSize, maxPerRow) => {
  const buttonWidth = getButtonWidth(shorthandSize);
  return (maxPerRow || max - min + 1) * (parseInt(buttonWidth, 10) + GAP_BETWEEN_RATING_BUTTONS);
};
const renderRatingButtons = (min, max, name, size, value, onChange) => {
  const buttons = [];
  for (let i = min; i <= max; i++) {
    buttons.push( /*#__PURE__*/_jsx(IconButton, {
      active: i === value,
      name: name,
      onClick: onChange && partial(onChange, syntheticEvent(i)),
      shape: "circle",
      size: size,
      children: i
    }, i));
  }
  return buttons;
};
export const NumberRatingComponent = props => {
  const {
      highRangeLabel = () => unescapedText('salesUI.UINumberRating.highRangeLabel'),
      label,
      lowRangeLabel = () => unescapedText('salesUI.UINumberRating.lowRangeLabel'),
      max = 10,
      maxPerRow,
      maxWidth,
      min = 1,
      name,
      onChange,
      required = false,
      size = 'sm',
      value
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const shorthandSize = toShorthandSize(size);
  const calculatedMaxWidth = maxWidth || calculateWidth(max, min, shorthandSize, maxPerRow);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  return /*#__PURE__*/_jsxs(View, Object.assign({}, tokenProps, domProps, {
    maxInlineSize: toPx(calculatedMaxWidth),
    children: [label && /*#__PURE__*/_jsx(FormLabel, {
      marginBlockEnd: "400",
      padding: "0",
      required: required,
      children: label
    }), /*#__PURE__*/_jsx(ButtonWrapper, {
      horizontalGap: GAP_BETWEEN_RATING_BUTTONS,
      verticalGap: GAP_BETWEEN_RATING_BUTTONS,
      justify: "center",
      children: renderRatingButtons(min, max, name, size, value, onChange)
    }), /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      flexDirection: "row",
      alignItems: "start",
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        maxBlockSize: "150px",
        children: /*#__PURE__*/_jsx(Text, {
          as: "small",
          color: "text-core-subtle",
          marginInlineEnd: "200",
          textAlign: "start",
          children: lazyEval(lowRangeLabel)
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        maxBlockSize: "150px",
        children: /*#__PURE__*/_jsx(Text, {
          as: "small",
          color: "text-core-subtle",
          marginInlineStart: "200",
          textAlign: "end",
          children: lazyEval(highRangeLabel)
        })
      })]
    })]
  }));
};
export const NumberRating = Controllable(NumberRatingComponent);
NumberRating.displayName = 'NumberRating';